import { Dialogs } from '@leverege/ui-elements';
import { Context, Config } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import UpdateItem from "../view/UpdateItem.js";
const {
  t,
  tf
} = I18N.ns('molten.imagine.actions.UpdateAction');
const create = relationship => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.UpdateItem`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    layout: {
      sort: 'item.edit1',
      sectionName: t('sectionName', {
        blueprintName: blueprint.name
      })
    },
    handles: cxt => {
      const {
        clientProps
      } = cxt;
      const rel = clientProps?.relationship;
      if (rel == null || rel.path !== path) {
        return false;
      }
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (targets == null || targets.length === 0 || targets.length > 1) {
        return false;
      }
      const delegate = DataSources.getActions(targets[0]);
      const can = delegate?.canUpdate();
      return can === true;
    },
    appearance: () => {
      return {
        name: t('appearanceName', {
          blueprintName: blueprint.name
        }),
        icon: Config.get('BlueprintActions', 'updateIcon', 'https://storage.googleapis.com/molten-ui-assets/update-action.png')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          delegate
        }
      } = context;
      Dialogs.show({
        component: UpdateItem,
        props: {
          target: Context.getTargetsOfType(context, blueprint.type)?.[0],
          relationship,
          delegate
        }
      });
    }
  };
};
export default {
  create
};